import r from"./whitespaces.mjs";var t=function(t,e){void 0===e&&(e=r);for(var a,o,f=0,s=t.length,i=e.length,n=!0;n&&f<s;)for(n=!1,a=-1,o=t.charAt(f);++a<i;)if(o===e[a]){n=!0,f++;break}return f>=s?"":t.substr(f,s)};export{t as default};
//# sourceMappingURL=ltrim.mjs.map
